export enum ContentTypeEnum {
    PRESS_RELEASE = 'PRESS_RELEASE',
    EMAIL = 'EMAIL',
    PUBLIC_STATEMENT = 'PUBLIC_STATEMENT',
    PR_ACTION_PLAN = 'PR_ACTION_PLAN',
    CRISIS_RESPONSE_TEMPLATE = 'CRISIS_RESPONSE_TEMPLATE',
    INTERVIEW_NOTES_AND_TALKING_POINTS = 'INTERVIEW_NOTES_AND_TALKING_POINTS',
    BLOG = 'BLOG',
    NEWSLETTER = 'NEWSLETTER',
    OP_ED_ARTICLE = 'OP_ED_ARTICLE',
    X = 'X',
    FACEBOOK = 'FACEBOOK',
    INSTAGRAM = 'INSTAGRAM',
    LINKEDIN = 'LINKEDIN',
    REDDIT = 'REDDIT',
    VIDEO_SCRIPT = 'VIDEO_SCRIPT',
    PODCAST_SCRIPT = 'PODCAST_SCRIPT',
    WHITE_PAPER_SYNOPSIS = 'WHITE_PAPER_SYNOPSIS',
    POINT_FORM_LIST = 'POINT_FORM_LIST',
    CASE_STUDY = 'CASE_STUDY',
    LIST_OF_RELATED_EXPERT_ROLES = 'LIST_OF_RELATED_EXPERT_ROLES',
    LIST_OF_SENSITIVE_ISSUES = 'LIST_OF_SENSITIVE_ISSUES',
};
